import { Api } from "../client/generated/Api";

const browserApi = new Api({
  baseURL: import.meta.env.VITE_API_URL,
  withCredentials: true,
});

const browserApiWithoutCredentials = new Api({
  baseURL: import.meta.env.VITE_API_URL,
  withCredentials: false,
});

export default {
  browser: browserApi,
  browserWithoutCredentials: browserApiWithoutCredentials,
};
